const STORAGE_KEY = 'pepoll_geo_consent';

interface GeoConsentPreference {
  allowed: boolean;
  consentedAt: string;
}

class GeoConsentService {
  getPreference(): GeoConsentPreference | null {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw) as GeoConsentPreference;
    } catch {
      return null;
    }
  }

  setPreference(allowed: boolean): GeoConsentPreference {
    const preference: GeoConsentPreference = {
      allowed,
      consentedAt: new Date().toISOString(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(preference));
    return preference;
  }

  clearPreference(): void {
    localStorage.removeItem(STORAGE_KEY);
  }
}

export const geoConsentService = new GeoConsentService();
